module.exports = __webpack_public_path__ + "media/images/products/products/support-98b2cecd9829365427eeb331f1d38f06.jpg";